import { useEffect, useState, useRef } from 'react';
import { useIntl } from 'react-intl';

import {
  useDeckCardTyped,
  useDeckCardIndex,
  useSearchAndShuffleContext,
} from '../../context';
import { useConsent } from '../../use-consent';

import { Tooltip } from './first-taken-job-tooltip.styled';
import { useJobCardTracking } from './use-job-card-tracking';

export const FirstTakenJobTooltip: React.FC = () => {
  const itWasOpenedOnce = useRef(false);
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const { addConsent } = useConsent();
  const { tooltipOnCardId } = useSearchAndShuffleContext();
  const card = useDeckCardTyped(['TakenJob', 'AvailableJob'] as const);
  const deckIndex = useDeckCardIndex();
  const { trackFirstTakenJobTooltip, trackCloseFirstTakenJobTooltip } =
    useJobCardTracking();

  const closeHandler = (): void => {
    setOpen(false);
    addConsent();
    trackCloseFirstTakenJobTooltip({
      status: card.data.type,
      cardType: 'job_reco',
      itemUrn: card.data.urn || '',
      trackingToken: card.data.trackingToken || '',
      position: deckIndex || -1,
    });
  };

  useEffect(() => {
    if (card.data?.type === 'TakenJob' && tooltipOnCardId === card.data.id) {
      setOpen(true);
      itWasOpenedOnce.current = true;
      if (card.data?.urn && card.data?.trackingToken && deckIndex) {
        trackFirstTakenJobTooltip({
          status: card.data.type,
          cardType: 'job_reco',
          itemUrn: card.data.urn,
          trackingToken: card.data.trackingToken,
          position: deckIndex,
        });
      }
    }
  }, [tooltipOnCardId, card.data?.type]);

  return (
    <>
      <Tooltip
        onClick={closeHandler}
        markerText={intl.formatMessage({
          id: 'DREAM_MACHINE_ENTRY_POINT_NEW_MARKER',
          defaultMessage: 'DREAM_MACHINE_ENTRY_POINT_NEW_MARKER',
        })}
        bodyText={intl.formatMessage({
          id: 'SEARCH_AND_SWIPE_TOOLTIP_BODY',
          defaultMessage: 'SEARCH_AND_SWIPE_TOOLTIP_BODY',
        })}
        trigger=""
        variant="highlighted"
        open={open}
        modal={false}
      />
    </>
  );
};
